import { render, staticRenderFns } from "./ContainerRegistry.vue?vue&type=template&id=0b59d087"
import script from "./ContainerRegistry.vue?vue&type=script&lang=js"
export * from "./ContainerRegistry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports